import React from 'react';

function CalendarDateSelector(props) {
    function clickHandler(e) {
        e.preventDefault();
        e.stopPropagation();
        props.changeDate(props.date.DBDate);
    }

    return (
        <a href="#!" className={props.selected ? "active" : ""} onClick={clickHandler}>{props.date.date}</a>
    );
}

export default CalendarDateSelector;